import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const DATE_DISPLAY_FORMAT = "MM/DD/YYYY";
export const DATE_TIME_DISPLAY_FORMAT = "MM/DD/YYYY hh:mm A";
export const TIME_DISPLAY_FORMAT = "hh:mm A";
export const API_DATE_FORMAT = "YYYY-MM-DD";

export function formatDate(value) {
  return value ? dayjs(value).format(DATE_DISPLAY_FORMAT) : "";
}

export function formatDateTime(value) {
  return value ? dayjs(value).format(DATE_TIME_DISPLAY_FORMAT) : "";
}

export function formatUtcDateTime(value) {
  const date = dayjs.utc(value);
  return date.isValid() ? date.format(DATE_TIME_DISPLAY_FORMAT) : "N/A";
}

export function formatTime(value) {
  return value ? dayjs(value).format(TIME_DISPLAY_FORMAT) : "";
}

export function formatApiDate(value) {
  return value ? dayjs(value).format(API_DATE_FORMAT) : null;
}

export function formatApiDateTime(value) {
  return value ? dayjs(value).toISOString() : null;
}

export function compareDateTime(a, b) {
  const aTime = a ? dayjs(a).valueOf() : 0;
  const bTime = b ? dayjs(b).valueOf() : 0;
  return aTime - bTime;
}
